const style = {
  "comment": {
    "color": "var(--bs-gray-600)"
  },
  "prolog": {
    "color": "var(--bs-gray-400)"
  },
  "doctype": {
    "color": "var(--bs-gray-400)"
  },
  "cdata": {
    "color": "var(--bs-gray-400)"
  },
  "punctuation": {
    "color": "#999"
  },
  "namespace": {
    "Opacity": ".7"
  },
  "property": {
    "color": "var(--bs-primary)"
  },
  "tag": {
    "color": "var(--bs-red)"
  },
  "boolean": {
    "color": "var(--bs-red)"
  },
  "number": {
    "color": "var(--bs-red)"
  },
  "constant": {
    "color": "var(--bs-red)"
  },
  "symbol": {
    "color": "var(--bs-red)"
  },
  "deleted": {
    "color": "var(--bs-red)"
  },
  "selector": {
    "color": "var(--bs-pink)"
  },
  "attr-name": {
    "color": "var(--bs-secondary)"
  },
  "string": {
    "color": "var(--bs-red)"
  },
  "char": {
    "color": "var(--bs-red)"
  },
  "builtin": {
    "color": "#690"
  },
  "inserted": {
    "color": "#690"
  },
  "operator": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  "entity": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)",
    "cursor": "help"
  },
  "url": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  "atrule": {
	"color": "var(--bs-secondary)"
  },
  "attr-value": {
	"color": "var(--bs-secondary)"
  },
  "keyword": {
	"color": "var(--bs-secondary)"
  },
  "function": {
    "color": "#DD4A68"
  },
  "class-name": {
    "color": "#DD4A68"
  },
  "regex": {
    "color": "#e90"
  },
  "important": {
    "color": "#e90",
    "fontWeight": "bold"
  },
  "variable": {
    "color": "#e90"
  },
  "bold": {
    "fontWeight": "bold"
  },
  "italic": {
    "fontStyle": "italic"
  }
};

export default style
